/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStateImportRequestResponseDto } from './EventStateImportRequestResponseDto';
import {
    EventStateImportRequestResponseDtoFromJSON,
    EventStateImportRequestResponseDtoFromJSONTyped,
    EventStateImportRequestResponseDtoToJSON,
    EventStateImportRequestResponseDtoToJSONTyped,
} from './EventStateImportRequestResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListEventStateImportRequestsResponseDto
 */
export interface ListEventStateImportRequestsResponseDto {
    /**
     * 
     * @type {Array<EventStateImportRequestResponseDto>}
     * @memberof ListEventStateImportRequestsResponseDto
     */
    data: Array<EventStateImportRequestResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListEventStateImportRequestsResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListEventStateImportRequestsResponseDto interface.
 */
export function instanceOfListEventStateImportRequestsResponseDto(value: object): value is ListEventStateImportRequestsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListEventStateImportRequestsResponseDtoFromJSON(json: any): ListEventStateImportRequestsResponseDto {
    return ListEventStateImportRequestsResponseDtoFromJSONTyped(json, false);
}

export function ListEventStateImportRequestsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEventStateImportRequestsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EventStateImportRequestResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListEventStateImportRequestsResponseDtoToJSON(json: any): ListEventStateImportRequestsResponseDto {
    return ListEventStateImportRequestsResponseDtoToJSONTyped(json, false);
}

export function ListEventStateImportRequestsResponseDtoToJSONTyped(value?: ListEventStateImportRequestsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EventStateImportRequestResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

